// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"48":"657d6f35","188":"18a28ade","327":"8102d188","594":"6812dab8","957":"8db0e005"}[chunkId] + ".js";
};